import DirectDebitSepaHeader from './direct-debit-sepa-header';

export default DirectDebitSepaHeader;
